module.exports = __webpack_public_path__ + "static/media/slide-9.png:Zone.40254007.Identifier";